import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoriesListView } from 'src/modules/role/admin/components/categories/list/component';
import { CreateOrgansation } from 'src/modules/role/organisation-admin/components/organisation/create/component';
import { OrganisationsView } from 'src/modules/role/organisation-admin/components/organisation/view/component';
import { UserView } from 'src/modules/role/user-admin/components/user/view/component';
import { CallbackComponent } from './components/callback/callback.component';
import { Dashboard } from './components/dashboard/component';
import { LoginComponent } from './components/login/login.component';
import { LoggedInGuard } from './guards/logged-in.guard';
import { LoggedOutGuard } from './guards/logged-out.guard';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoggedOutGuard],
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'dashboard/:tab',
    component: Dashboard,
    canActivate: [LoggedInGuard],
  },
  {
    path: 'user/:userId',
    component: UserView,
    canActivate: [LoggedInGuard],
  },
  {
    path: 'user/new',
    component: UserView,
    canActivate: [LoggedInGuard],
  },
  {
    path: 'organisation/new',
    component: CreateOrgansation,
    canActivate: [LoggedInGuard],
  },
  {
    path: 'category/:type/:categoryId',
    component: CategoriesListView,
    canActivate: [LoggedInGuard],
  },
  {
    path: 'organisations/:organisationId',
    component: OrganisationsView,
    canActivate: [LoggedInGuard],
  },
  // {
  //   path: 'category/ballot/:categoryId',
  //   component: CategoriesListView,
  //   canActivate: [LoggedInGuard],
  // },
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
